import React from 'react'
import JSONImportInput from './form/JSONImportInput'
import WordImportInput from './form/WordImportInput'
import GlobalStorage from './storage/GlobalStorage'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
    this.GS = new GlobalStorage()
  }

  render()
  {
    return (
        <div style={{position: `relative`, height: `100%`, display: `flex`, flexDirection: `column`}}>
          <h3>{`Import`}</h3>
          <p>
            <label>Import raw JSON file here</label>
            <br/>
            <JSONImportInput
            onChange={(e, filename) => {
              if (filename)
              {
                alert("" + filename + " Imported.")
              }
            }}/>
            <label>Import Word file here</label>
            <br/>
            <WordImportInput
            onChange={(e, filename) => {
              if (filename)
              {
                alert("" + filename + " Imported.")
              }
            }}/>

          </p>
        </div>
        
    )
  }
}